/**
 * Copy a string to the clipboard, returning whether it worked.
 *
 * The async Clipboard API is blocked outside secure contexts and refused by
 * some browsers without a permission prompt, so this falls back to the old
 * hidden-textarea trick — a guest copying their play link is exactly the moment
 * we don't want to leave someone stuck.
 */
export const copyText = async (text: string, doc: Document = document): Promise<boolean> => {
  if (!text) {
    return false
  }

  try {
    const clipboard = (globalThis as any).navigator?.clipboard

    if (clipboard?.writeText) {
      await clipboard.writeText(text)

      return true
    }
  } catch {
    // Fall through to the textarea below.
  }

  try {
    const field = doc.createElement('textarea')
    field.value = text
    field.setAttribute('readonly', '')
    field.style.position = 'fixed'
    field.style.opacity = '0'
    doc.body.appendChild(field)
    field.select()
    const copied = doc.execCommand('copy')
    doc.body.removeChild(field)

    return !!copied
  } catch {
    return false
  }
}
